import React, { useState, useEffect } from 'react'
import { ConfigItem } from './ConfigItem'
import Select, { components } from 'react-select'
import { FormGroup, Form,Row,Col,Button } from 'react-bootstrap'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Autocomplete, createFilterOptions } from '@material-ui/lab'
import { TextField } from '@material-ui/core'
import { Checkbox, Radio } from '@mui/material'
import { MuiThemeProvider, InputAdornment } from '@material-ui/core'
import { autocompleteTheme } from 'designer/component/system/themes/elementTheme'
import httpClient from 'utility/httpClient.util'
import Field from 'designer/component/system/menu/search/Field'
import { REPORT_PARAMETER_CONDITION_OPERATORS } from './reportParameterCondition.util'
import { getReportParameterType } from './reportParameterValue.util'


const typeOption = [
    { label: 'Text', value: 'text' },
    { label: 'Date', value: 'date' },
    { label: 'Date & Time', value: 'datetime' },
    { label: 'Dropdown', value: 'dropdown' },
    { label: 'Checkbox', value: 'checkbox' },
    { label: 'Number', value: 'number' },
    { label: 'Yes or No', value: 'boolean' }
]

const apiOptionMock = [
    {label : 'คลีนิก',value:'/core/specialty',apiDataLabel:'name',apiDataValue:'specialtyCode',apiDataLabelTemplate:'${specialtyCode} - ${name}'},
    {label : 'ห้องตรวจ',value:'/core/place/search',apiDataLabel:'name',apiDataValue:'placeCode',apiDataLabelTemplate:'${placeCode} - ${name}'},
    {label : 'Ward',value:'/core/ward',apiDataLabel:'name',apiDataValue:'wardCode',apiDataLabelTemplate:'${wardCode} - ${name}'},
    {label : 'แพทย์',value:'/hr/employee/getDoctorNurse'},
    {label : 'บุคคลากร',value:'/hr/employee'},
    {label : 'พยาบาล',value:'/hr/employee/getNurseIpd'},
    {label : 'เภสัช',value:'/hr/employee/getPharmacist',apiDataLabel:'fullName',apiDataValue:'pharmacistId'},
]

const dsOptionMock = [
    {label : 'xxxxx',value:1}
]

const ParameterMenu = ({ inputs,datasource, onChange = () => { } }) => {
    
    const [parameter, setParameter] = useState([])
    const [iconOption, setIconOption] = useState([])
    const [selectedIcon, setSelectedIcon] = useState(null)
    const [pageOption, setPageOption] = useState([])
    const [apiOption,setApiOption] = useState([])
    const [datasourceOption, setDatasourceOption] = useState([]);

    useEffect(()=>{
        setDatasourceOption(datasource.map(({ name, dataSourceId }) => ({ label: name, value: dataSourceId })))
    },[datasource])

    useEffect(async () => {
        setParameter(inputs.map((item) => {
            return { collapse: true, ...item }
        }))
    }, [inputs])

    useEffect(async () => {
        getIconList()
        await fetchApi()
    }, [])

    const fetchApi = async () => {
        const resp = (await httpClient.get(`/designer/form-design/search?&isEnabled=1&page=1&perPage=1000&searchKey=&isPage=1&isWidget=0&moduleCode=REPORT`)).data

        if (resp) {
            setPageOption(resp.data.map((item) => {
                return { label: item.name, value: item.code, data: { code: item.code, name: item.name, isPage: item.isPage } }
            }))
        }

        const resp2 = (await httpClient.get(`/core/config/report/report_dropdown_api_options`)).data

        if (resp2) {
            setApiOption(resp2?.data?.jsonData?.apiOption && resp2.data.jsonData.apiOption.map((item) => {
                return { ...item } 
            }))
        }
    }


    const isIconAvailable = (iconClass) => {
        const testElement = document.createElement('i');
        testElement.className = iconClass;

        // Temporarily add the element to the DOM
        document.body.appendChild(testElement);

        // Get the 'content' property from the `::before` pseudo-element
        const contentValue = window.getComputedStyle(testElement, '::before').getPropertyValue('content');

        // Remove the test element
        document.body.removeChild(testElement);

        // If 'content' is set, it's an available icon
        return contentValue && contentValue !== 'none';
    };


    const getIconList = () => {
        let iconList = []
        library.add(fas)
        let fasArray = Object.keys(library.definitions.fas)
        fasArray.forEach((key) => {
            const iconClass = `fas fa-${key}`;
            if (isIconAvailable(iconClass)) {
                let icon = {
                    value: key,
                    iconClass: iconClass,
                    source: 'fas',
                }
                iconList.push(icon)
            }
        })

        setIconOption(iconList)
    }

    const updateIcon = (item, index, option) => {
        const newItem = { ...item, helpIcon: option }
        onChange && onChange(newItem)
        setParameter(prev =>
            prev.map((param, i) =>
                i === index ? { ...param, helpIcon: option } : param
            )
        );
    }


    const defaultFilterOptions = createFilterOptions()

    const filterOptions = (options, state) => {
        return defaultFilterOptions(options, state).slice(0, 50)
    }

    const IconAutoComplete = ({ item, index, iconSource, icon }) => {
        return (
            <MuiThemeProvider theme={autocompleteTheme}>
                <Autocomplete
                    onChange={(event, option) => updateIcon(item, index, option)}
                    options={iconOption}
                    getOptionLabel={(option) => option?.value || ''}
                    renderOption={(option) => (
                        <React.Fragment>
                            <i
                                className={`fas fa-${option.value} mr-1`}
                                size="sm"
                            /> {option.value}
                        </React.Fragment>
                    )}
                    filterOptions={filterOptions}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {iconSource === 'fas' && (
                                            <i
                                                className={`fas fa-${icon} mr-1`}
                                                size="sm"
                                            />
                                        )}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    )}
                    value={{ value: icon }}
                    sx={{ mb: 2, minWidth: 400 }}
                />
            </MuiThemeProvider>
        )
    }

    const renderSelectIcon = () => {
        return (
            <Select
                styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={document.body}
                // maxMenuHeight={options.length > 0 ? 48 * options.length : 48}
                options={iconOption}
                value={selectedIcon}
                onChange={async (e) => {
                    setSelectedIcon(e);
                }}
                components={{
                    Option: ({ data, ...props }) => (
                        <div {...props.innerProps} className="d-flex align-items-center">
                            <i className={`fas fa-${data.value} mr-1`} />  {data.value}
                        </div>
                    ),
                    SingleValue: ({ data }) => (
                        <div className="d-flex align-items-center">
                            <i className={`fas fa-${data.value} mr-1`} /> {data.value}
                        </div>
                    ),
                }}
            ></Select>
        )
    }

    const renderHelpUi = (item, index) => {
        return (<>
            <FormGroup row>
                <div>{'Help Icon'}</div>
                <div style={{ width: '100%' }}>


                    <IconAutoComplete item={item} index={index} iconSource={item?.helpIcon?.source} icon={item?.helpIcon?.value} />
                </div>
            </FormGroup>
            <FormGroup row>
                <div>{'Help Modal'}</div>
                <div style={{ width: '100%' }}>

                    <Select
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        menuPortalTarget={document.body}
                        isClearable={true}
                        // maxMenuHeight={options.length > 0 ? 48 * options.length : 48}
                        options={pageOption}
                        value={pageOption.find(option => option.value === item?.helpData?.code)}
                        onChange={async (e) => updateParamChange(item, index, 'helpData', e?.data)}
                    // components={{ Option: IconOption, SingleValue: CustomSingleValue }}
                    ></Select>
                </div>


            </FormGroup>
        </>)
    }

    const updateParamValues = (item, index, values) => {
        const newItem = { ...item, ...values }
        onChange && onChange(newItem)
        setParameter(prev =>
            prev.map((param, i) =>
                i === index ? { ...param, ...values } : param
            )
        );
    }

    const updateParamChange = (item, index, field, value) => {
        updateParamValues(item, index, { [field]: value })
    }

    const renderDropdownUi = (item, index,fieldName) => {
        const fieldData = item[fieldName] || {source:''}

        return (<div>
            <label>
                <Radio
                    color="primary"
                    value={true}
                    checked={fieldData?.source === 'custom'}
                    onChange={async (e) => updateParamChange(item, index, fieldName, { ...fieldData, source: 'custom' })}
                />
                Custom
            </label>
            <label>
                <Radio
                    color="primary"
                    value={false}
                    checked={fieldData?.source === 'api'}
                    onChange={async (e) => updateParamChange(item, index, fieldName, { ...fieldData, source: 'api' })}
                />
                API
            </label>
            <label>
                <Radio
                    color="primary"
                    value={false}
                    checked={fieldData?.source === 'datasource'}
                    onChange={async (e) => updateParamChange(item, index, fieldName, { ...fieldData, source: 'datasource' })}
                />
                Datasource
            </label>            
            {fieldData?.source === 'custom' && (
                <>
                    {
                        fieldData?.choices && fieldData?.choices.map((choice,cIndex) => (
                            <div className='d-flex'>
                                <div>     
                                 <Form.Control                                                                        
                                    placeholder='label'
                                    type="text"
                                    autoComplete="off"                                    
                                    value={choice.label}
                                    onChange={(e) => { 
                                        const choices =  fieldData?.choices
                                        choices[cIndex].label = e.target.value
                                        updateParamChange(item, index, fieldName, { ...fieldData, choices: choices  })
                                    }}
                                />   
                                </div>
                                <div>     
                                 <Form.Control                                                                        
                                    placeholder='value'
                                    type="text"
                                    autoComplete="off"                                    
                                    value={choice.value}
                                    onChange={(e) => { 
                                        const choices =  fieldData?.choices
                                        choices[cIndex].value = e.target.value
                                        updateParamChange(item, index, fieldName, { ...fieldData, choices: choices  })
                                    }}
                                />   
                                </div>
                                <div style={{lineHeight:'36px',cursor:'pointer'}} className='ml-1'>
                                    <i className='fas fa-trash text-c-red' onClick={()=>{
                                        const updatedChoices = fieldData?.choices.filter((_, iIndex) => iIndex !== cIndex); // Create a new array without the clicked item
                                        updateParamChange(item, index, fieldName, { 
                                          ...fieldData, 
                                          choices: updatedChoices // Pass the new array to update the state
                                        });
                                    }}/>
                                </div>
                            </div>
                        ))
                    }
                    <div><Button className='mt-2 w-100 btn btn-secondary' onClick={
                            async (e) => updateParamChange(item, index, fieldName, { ...fieldData, choices: (fieldData?.choices ||[]).concat({label:'',value:''}) })
                    }><i className='fas fa-plus' /></Button></div>
                </>
            )}
            {fieldData?.source === 'api' && (
                <FormGroup row>
                <div>{'From API'}</div>
                <div style={{ width: '100%' }}>

                    <Select
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        menuPortalTarget={document.body}
                        // maxMenuHeight={options.length > 0 ? 48 * options.length : 48}
                        options={apiOption}
                        value={apiOption.find(option => option.value === fieldData?.endpointUrl)}
                        onChange={async (e) => updateParamChange(item, index, fieldName, { ...fieldData,choices:[], 
                            endpointUrl: e?.value,apiDataLabel:e?.apiDataLabel,apiDataValue:e?.apiDataValue,apiDataLabelTemplate:e?.apiDataLabelTemplate })}
                    // components={{ Option: IconOption, SingleValue: CustomSingleValue }}
                    />
                </div>
            </FormGroup>
            )}
            {fieldData?.source === 'datasource' && (
                <FormGroup row>
                <div>{'From Datasource'}</div>
                <div style={{ width: '100%' }}>

                    <Select
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        menuPortalTarget={document.body}
                        // maxMenuHeight={options.length > 0 ? 48 * options.length : 48}
                        options={datasourceOption}
                        value={datasourceOption.find(option => option.value === fieldData?.dataSourceId)}
                        onChange={async (e) => updateParamChange(item, index, fieldName, { ...fieldData,choices:[], 
                            dataSourceId: e?.value })}
                    // components={{ Option: IconOption, SingleValue: CustomSingleValue }}
                    />
                </div>
            </FormGroup>
            )}
        </div>
        )
    }

    const getParamDisplayName = (item = {}) =>
        item.displayName || item.aliasName || item.title

    const getParamField = (item = {}) => item.field || item.title || ''

    const getConditionSourceOptions = (currentIndex) =>
        parameter
            .filter((item, index) => index !== currentIndex)
            .map((item) => ({
                label: `${getParamDisplayName(item)} (${getParamField(item)})`,
                value: getParamField(item),
            }))

    const getConditionSource = (item = {}) =>
        parameter.find(
            (source) => getParamField(source) === item?.visibleWhen?.field,
        )

    const updateVisibleWhen = (item, index, nextVisibleWhen) => {
        updateParamChange(item, index, 'visibleWhen', {
            ...item.visibleWhen,
            ...nextVisibleWhen,
            enabled: true,
        })
    }

    const renderConditionValue = (item, index) => {
        const condition = item.visibleWhen || {}
        if (condition.operator === 'notEmpty') return null

        const source = getConditionSource(item)
        const choices = source?.dropdownData?.choices || []
        const isMultiple = condition.operator === 'in'

        if (choices.length) {
            const conditionValues = Array.isArray(condition.value)
                ? condition.value
                : `${condition.value || ''}`.split(',').map((value) => value.trim())
            const selectedValue = isMultiple
                ? choices.filter((choice) =>
                    conditionValues
                        .some((value) => `${value}` === `${choice.value}`),
                )
                : choices.find((choice) => `${choice.value}` === `${condition.value}`)

            return (
                <FormGroup row>
                    <div>{'ค่าที่ใช้เปรียบเทียบ'}</div>
                    <div style={{ width: '100%' }}>
                        <Select
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            menuPortalTarget={document.body}
                            isClearable
                            isMulti={isMultiple}
                            options={choices}
                            value={selectedValue || (isMultiple ? [] : null)}
                            onChange={(selected) =>
                                updateVisibleWhen(item, index, {
                                    value: isMultiple
                                        ? (selected || []).map((choice) => choice.value)
                                        : selected?.value || '',
                                })
                            }
                        />
                    </div>
                </FormGroup>
            )
        }

        return (
            <FormGroup row>
                <div>{isMultiple ? 'ค่า (คั่นด้วยเครื่องหมายจุลภาค)' : 'ค่าที่ใช้เปรียบเทียบ'}</div>
                <div style={{ width: '100%' }}>
                    <Form.Control
                        type="text"
                        autoComplete="off"
                        placeholder={isMultiple ? 'daily, monthly' : 'ค่าของพารามิเตอร์ต้นทาง'}
                        value={Array.isArray(condition.value) ? condition.value.join(', ') : condition.value || ''}
                        onChange={(e) => updateVisibleWhen(item, index, { value: e.target.value })}
                    />
                </div>
            </FormGroup>
        )
    }

    const renderConditionalVisibility = (item, index) => {
        const conditionEnabled =
            item?.visibleWhen?.enabled === true || Boolean(item?.visibleWhen?.field)
        const sourceOptions = getConditionSourceOptions(index)
        const condition = item.visibleWhen || {}

        return (
            <div className='border-top pt-2 mt-2'>
                <Form.Check
                    custom
                    type="switch"
                    id={`conditional-visibility-${getParamField(item)}`}
                    label="แสดงตามเงื่อนไข"
                    checked={conditionEnabled}
                    disabled={!sourceOptions.length}
                    onChange={(e) => {
                        if (!e.target.checked) {
                            updateParamValues(item, index, {
                                visibleWhen: null,
                                requiredWhenVisible: false,
                                clearWhenHidden: true,
                            })
                            return
                        }

                        updateParamChange(item, index, 'visibleWhen', {
                            enabled: true,
                            field: sourceOptions[0]?.value || '',
                            operator: 'equals',
                            value: '',
                        })
                    }}
                />
                <small className="text-muted d-block mb-2">
                    ซ่อนพารามิเตอร์นี้จนกว่าค่าของพารามิเตอร์ต้นทางจะตรงตามเงื่อนไข
                </small>
                {conditionEnabled && (
                    <>
                        <FormGroup row>
                            <div>{'พารามิเตอร์ต้นทาง'}</div>
                            <div style={{ width: '100%' }}>
                                <Select
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    menuPortalTarget={document.body}
                                    options={sourceOptions}
                                    value={sourceOptions.find((option) => option.value === condition.field) || null}
                                    onChange={(selected) => updateVisibleWhen(item, index, {
                                        field: selected?.value || '',
                                        value: '',
                                    })}
                                />
                            </div>
                        </FormGroup>
                        <FormGroup row>
                            <div>{'เงื่อนไข'}</div>
                            <div style={{ width: '100%' }}>
                                <Select
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    menuPortalTarget={document.body}
                                    options={REPORT_PARAMETER_CONDITION_OPERATORS}
                                    value={REPORT_PARAMETER_CONDITION_OPERATORS.find(
                                        (option) => option.value === (condition.operator || 'equals'),
                                    )}
                                    onChange={(selected) => updateVisibleWhen(item, index, {
                                        operator: selected?.value || 'equals',
                                        value: selected?.value === 'notEmpty' ? '' : condition.value || '',
                                    })}
                                />
                            </div>
                        </FormGroup>
                        {renderConditionValue(item, index)}
                        <Form.Check
                            custom
                            type="checkbox"
                            id={`required-when-visible-${getParamField(item)}`}
                            label="บังคับกรอกเมื่อแสดง"
                            checked={item.requiredWhenVisible === true}
                            onChange={(e) => updateParamChange(
                                item,
                                index,
                                'requiredWhenVisible',
                                e.target.checked,
                            )}
                        />
                        <Form.Check
                            custom
                            type="checkbox"
                            id={`clear-when-hidden-${getParamField(item)}`}
                            label="ล้างค่าเมื่อซ่อน"
                            checked={item.clearWhenHidden !== false}
                            onChange={(e) => updateParamChange(
                                item,
                                index,
                                'clearWhenHidden',
                                e.target.checked,
                            )}
                        />
                    </>
                )}
            </div>
        )
    }

    const renderParameterTitle = (item = {}) => {
        const displayName = getParamDisplayName(item)
        if (!displayName || displayName === item.title) return item.title

        return (
            <div>
                <div>{displayName}</div>
                <div style={{ fontSize: '12px', opacity: 0.7 }}>{item.title}</div>
            </div>
        )
    }

    const renderSetting = (item, index) => {
        return (
            <div className='mt-1'>
                <FormGroup row>
                    <div>{'Display Name'}</div>
                    <div style={{ width: '100%' }}>
                        <Form.Control
                            type="text"
                            autoComplete="off"
                            placeholder={item.title}
                            value={item.displayName || item.aliasName || ''}
                            onChange={(e) => updateParamChange(item, index, 'displayName', e.target.value)}
                        />
                    </div>
                </FormGroup>
                <FormGroup row>
                    <div>{'Param Type'}</div>
                    <div style={{ width: '100%' }}>

                        <Select
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            menuPortalTarget={document.body}
                            // maxMenuHeight={options.length > 0 ? 48 * options.length : 48}
                            options={typeOption}
                            value={typeOption.find(option => option.value === getReportParameterType(item))}
                            onChange={async (e) => updateParamChange(item, index, 'paramType', e.value)}
                        // components={{ Option: IconOption, SingleValue: CustomSingleValue }}
                        />
                    </div>
                </FormGroup>
                {renderConditionalVisibility(item, index)}
                {item?.paramType === 'text' && renderHelpUi(item, index)}
                {item?.paramType === 'dropdown' && renderDropdownUi(item, index,'dropdownData')}
                {item?.paramType === 'checkbox' && renderDropdownUi(item, index,'checkboxData')}
            </div>
        )
    }

    return (
        <div>
            {parameter.map((item, index) => (
                <div
                    key={index}
                    className="b-c-blue pb-1 pt-1 pl-2 pr-2 mb-1 "
                    style={{ borderRadius: '10px', cursor: 'pointer' }}
                >
                    <div className='d-flex justify-content-between align-items-center' onClick={() => {
                        // Toggle the collapse state for this specific item
                        setParameter(prev =>
                            prev.map((param, i) =>
                                i === index ? { ...param, collapse: !param.collapse } : param
                            )
                        );
                    }}>
                        {renderParameterTitle(item)}
                        {item.collapse ? <i className="fas fa-angle-right" /> : <i className="fas fa-angle-up" />}
                    </div>
                    {!item.collapse && item.collapse === false && renderSetting(item, index)} {/* Render renderSetting() only if collapse is false */}
                </div>
            ))}
        </div>
    )
}

export default ParameterMenu
